import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1.5rem',
    minHeight: 'calc(100vh - 100px)',
    width: '100vw',
    maxWidth: '100%',
    paddingBottom: '1.5rem',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '1.5rem',
    width: '100%',
    maxWidth: 450,
  },

  titleBar: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
    maxWidth: 450,
    '& :first-child': {
      marginBottom: '2rem',
    },
  },

  title: {
    color: 'black',
    fontSize: '2rem',
    fontWeight: '700',
    marginBottom: '1rem',
    maxWidth: '100vw',
  },

  subtitle: {
    fonSize: "1.4 rem",
    fontWeight: '500',
    marginBottom: '1rem',
    padding: '0 2rem',
  },
  
  locker: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 75,
    height: 75,
    fontSize: 50,
    color: Colors.gray,
    border: `solid 5px ${Colors.gray}`,
    borderRadius: '50%',
    marginTop: '1.5rem',

    '& > svg': {
      marginTop: '1.25rem', 
    },
  },

  formBox: {
    width: 500,
    maxWidth: '80%',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    alignItems: 'center',
    '& button': {
      marginTop: '1rem',
    },
  },
}))

export default styles
